module.exports = __webpack_public_path__ + "img/login-bg.a914551b.png";